import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiX } from 'react-icons/fi';

export default function Footer() {
  const [isTermsOpen, setIsTermsOpen] = useState(false);

  const HELP_URL = "https://pomoc.rzutnieruchomosci.pl";

  return (
    <footer id="contact" className="bg-white pt-20 pb-10">
      <div className="max-w-8xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-12 mb-16">
          <div className="col-span-2 lg:col-span-2">
            <img 
              src="https://media.swipepages.com/2025/11/615ca9d98dcf7f0011c44053/rzut-nieruchomosci-l.png" 
              alt="Logo" 
              className="h-[32px] mb-6 opacity-80 grayscale" 
            />
            <p className="text-[14px] text-gray-500 leading-relaxed max-w-xs font-normal">
              Najnowocześniejsze narzędzie dla biur nieruchomości i profesjonalistów w Polsce. Twórz rzuty, które sprzedają.
            </p>
          </div>

          <div>
            <h4 className="text-[12px] font-semibold text-gray-900 uppercase tracking-widest mb-6">Produkt</h4>
            <ul className="space-y-3">
              <li><a href="#features" className="text-[14px] text-gray-500 hover:text-gray-900 transition-colors">Funkcje</a></li>
              <li><a href="#pricing" className="text-[14px] text-gray-500 hover:text-gray-900 transition-colors">Cennik</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[12px] font-semibold text-gray-900 uppercase tracking-widest mb-6">Zasoby</h4>
            <ul className="space-y-3">
              <li><a href={HELP_URL} target="_blank" rel="noopener noreferrer" className="text-[14px] text-gray-500 hover:text-gray-900 transition-colors">Pomoc</a></li>
              <li><a href="https://pomoc.rzutnieruchomosci.pl" target="_blank" rel="noopener noreferrer" className="text-[14px] text-gray-500 hover:text-gray-900 transition-colors">Przewodniki</a></li>
              <li>
                <button 
                  onClick={() => setIsTermsOpen(trpue)}
                  className="text-[14px] text-gray-500 hover:text-gray-900 transition-colors text-left"
                >
                  Regulamin
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-[12px] font-semibold text-gray-900 uppercase tracking-widest mb-6">Prawne</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-[14px] text-gray-500 hover:text-gray-900 transition-colors">Prywatność</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[12px] font-semibold text-gray-900 uppercase tracking-widest mb-6">Kontakt</h4>
            <ul className="space-y-4">
              <li>
                <div className="text-[12px] text-gray-400 mb-1">Telefon</div>
                <a href="tel:+48799780725" className="text-[14px] text-[#1F2937] hover:text-gray-600 transition-colors font-medium">
                  (+48) 799 780 725
                </a>
              </li>
              <li>
                <div className="text-[12px] text-gray-400 mb-1">E-mail</div>
                <a href="mailto:kontakt@rzutnieruchomosci.pl" className="text-[14px] text-[#1F2937] hover:text-gray-600 transition-colors font-medium">
                  kontakt@rzutnieruchomosci.pl
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-200/60 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[13px] text-gray-400 font-normal">
            &copy; 2026 InfoImagine. Wszelkie prawa zastrzeżone.
          </p>
          <div className="flex gap-6">
            <a href="https://www.wirtualnyspacer360.pl/" className="text-[13px] text-gray-400 hover:text-gray-900 font-medium transition-colors">Wirtualny Spacer 360</a>
            <a href="https://www.iformularze.pl/" className="text-[13px] text-gray-400 hover:text-gray-900 font-medium transition-colors">iFormularze</a>
          </div>
        </div>
      </div>

      {/* Regulamin Modal Layer */}
      <AnimatePresence>
        {isTermsOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] flex items-center justify-center bg-gray-900/80 p-4 backdrop-blur-sm"
            onClick={() => setIsTermsOpen(false)}
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 20 }}
              className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[80vh] overflow-hidden flex flex-col relative"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex items-center justify-between p-6 border-b border-gray-100">
                <h3 className="text-xl font-bold text-gray-900">Regulamin Serwisu</h3>
                <button 
                  onClick={() => setIsTermsOpen(false)}
                  className="p-2 rounded-full hover:bg-gray-100 transition-colors"
                >
                  <SafeIcon icon={FiX} className="w-6 h-6 text-gray-500" />
                </button>
              </div>
              <div className="flex-1 overflow-y-auto p-8 prose prose-slate max-w-none">
                <p className="text-gray-600 leading-relaxed mb-6">
                  Poniżej znajdują się warunki korzystania z serwisu Rzut Nieruchomości. Prosimy o uważne zapoznanie się z poniższymi zapisami przed rozpoczęciem korzystania z naszych usług.
                </p>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">§1 Postanowienia ogólne</h4>
                <p className="text-gray-500 text-sm mb-4">
                  Niniejszy regulamin określa zasady korzystania z platformy Rzut Nieruchomości, dostępnej pod adresem rzutnieruchomosci.pl. Serwis świadczy usługi drogą elektroniczną polegające na udostępnieniu interaktywnego kreatora rzutów.
                </p>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">§2 Świadczenie usług</h4>
                <p className="text-gray-500 text-sm mb-4">
                  Dostęp do pełnych funkcjonalności kreatora rzutów jest odpłatny i odbywa się po wykupieniu odpowiedniego pakietu licencyjnego. Płatności realizowane są za pośrednictwem bezpiecznych operatorów płatności.
                </p>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">§3 Prawa i obowiązki</h4>
                <p className="text-gray-500 text-sm mb-6">
                  Użytkownik zobowiązuje się do korzystania z serwisu zgodnie z przeznaczeniem i obowiązującym prawem. Wygenerowane rzuty mogą być wykorzystywane komercyjnie w ramach aktywnej licencji.
                </p>
                {/* Dodać można więcej sekcji regulaminu tutaj */}
                <div className="p-4 bg-gray-50 rounded-lg border border-gray-100 text-center">
                  <p className="text-xs text-gray-400">Ostatnia aktualizacja: 15 stycznia 2026 r.</p>
                </div>
              </div>
              <div className="p-6 border-t border-gray-100 flex justify-end">
                <button 
                  onClick={() => setIsTermsOpen(false)}
                  className="px-6 py-2 bg-[#1F2937] text-white rounded-lg font-semibold hover:bg-gray-800 transition-colors"
                >
                  Zamknij
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </footer>
  );
}